import {getDetails, userRights, getLanguages, bulkUpdate, getAuthorScrappedNames, getPublicationContentList, updatePublicationContentList, createPublicationContentList, removePublicationContentList, bulkUpdatePublicationContentList, validateScreenName, createScreenName, getFeedsOriginList, mergeScrappedName, refreshOrigin} from '@/libs/api/api'
import {message, loader, getImageUrl, onError, copyText, navigateTo, copyElement, errorHandler, logout} from '@/libs/helper'
import {cloneDeep, isEmpty, filter, orderBy, sortBy, uniqBy} from 'lodash'
import constants from '@/libs/constant/constants'
import articlesTableMixin from '@/mixins/articlesTableMixin'

export default {
    name: 'PublicationForm',
    props: {},
    mixins: [articlesTableMixin],

    computed: {
        isDisabledChangeGuidAuthor () {
            if (isEmpty(this.authorToBeReplaced) || this.isProgress || this.isFinal) return true
            return false
        }
    },
    
    components: {
        AddNewAuthor: ()=> import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/AddNewAuthor/AddNewAuthor.vue') ,
        SocialMediaForm: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/SocialMediaForm/SocialMediaForm.vue'), 
        SearchDropdown: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/SearchDropdown/SearchDropdown.vue'), 
        RegisteredList: () => import(/* webpackChunkName: "group-admin" */'@/components/component/RegisteredList/RegisteredList.vue'), 
        AdminSearch: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/AdminSearch/AdminSearch.vue'), 
        ImageUpload: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/ImageUpload/ImageUpload.vue'),
        LocationForm: () => import(/* webpackChunkName: "group-admin" */'@/components/component/admin/LocationForm/LocationForm.vue'),
        ReplaceMeta: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/ReplaceMeta/ReplaceMeta.vue'),
        Table: () => import(/* webpackChunkName: "group-admin" */'@/components/component/Reuse/Table/Table.vue'),
    },
    beforeMount() {
        this.$store.dispatch('setShowTableSettings', false)
        this.$store.dispatch('setContainer', true)
        getLanguages()
                .then((response)=>{
                    this.languages = sortBy(cloneDeep(response.languages), 'name') || []
                })
                .catch((error)=>{
                    console.warn('error', error);
                })
        this.getMetaList('PUBLICATION')
        this.getUserRights()
        this.getContentList()
    },
    data() {
        return {
            category: 'PUBLICATION',
            sort: true,
            sortScrappedName: true,
            des: {},
            address: {},
            publisher: {},
            author: {},
            authors: [],
            formData: {},
            contentData: {},
            metaToAdd: {},
            metaAuthor: {},
            cleanInput: false,
            getUserData: {},
            publicationImage: {},
            selectedLanguage: {},
            isEmpty,
            showClearable: false,
            countryName: '',
            urls: [],
            urlToAdd: {url: ''},
            isReplace: false,
            navigateTo,
            copyText,
            getImageUrl,
            publicationLanguage: {},
            languages: [],
            languageName: '',
            publication: {},
            constants,
            domain: 'domain',
            content: 'url',
            imagePreview: '',
            socialMedia: {},
            managing_editor: '',
            copyRight: '',
            activeTab: constants.PUBLISHER_TABS.CONTENT_DB,
            onError,
            isAddNewAuthor: false,
            tableSettings: {
                headings: {
                  scrapped_name: 'Scrapped Name',
                  author_guid: 'Author GUID',
                  author_details: 'Author Details',
                  settings: ''
                },
                sortable: ['scrapped_name', 'author_details'],
                // sortIcon: { base: 'as-nova', up: 'nova-tablesortinga-z', down: 'nova-tablesortingz-a', is: 'nova-tablesorting' },
                filterable: [],
                filterByColumn: true,
                pagination: {chunk: 10}
              },
              columns: ['scrapped_name', 'author_guid', 'author_details', 'settings'],
              feedColumns: ['checkbox', 'name', 'url', 'description', 'update_frequncy', 'last_content_at', 'settings'],
              feedSettings: {
                headings: {
                    checkbox: '',
                    name: 'Feed name',
                    url: 'Feed URL',
                    description: 'Feed description',
                    update_frequncy: 'Frequency',
                    last_content_at: 'Last Update',
                    settings: ''
                  },
                  sortable: ['none'],
                  filterable: [],
                  filterByColumn: true,
                  pagination: {chunk: 10}
              },
              feedData: [],
              treeData: [],
              contentLabel: '',
              contentPath: '',
              contentDomain: '',
              validateSlug: function (rule, value, callback) {
                /* eslint-disable */
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if ((isEmpty(value)) || (value && value.length > 20) || (value && regex.test(value))) callback(new Error('Invalid screen name'))
                if (!isEmpty(value) && checkSpaces.test(value)) callback(new Error('Spaces are not allowed'))
                else callback()
            },
            // change guid
            currentAuthor: {},
            authorToBeReplaced: {},
            isChangeGuid: false,
            isFinal: false,
            isProgress: false,
            // article listing params publication
            percentage: 0,
            authorSearch: ''
        }
    },

    watch: {
        activeTab (value) {
            if (value === constants.PUBLISHER_TABS.ARTICLES) {
                this.changePage(1)
            }
        }
    },

    methods: {
        getMetaList: async function (type, fetchData, isLoader) {
            try{
                if (fetchData === undefined) {
                    if (!isLoader) loader(this, true)
                    this.formData = await getDetails(type.toLowerCase(), this.$route.params.id)
                    // to get the content feeds
                    this.getFeedsList(this.formData)
                }
                this.contentData = cloneDeep(this.formData)
                this.setValues(this.contentData)
                if (!isLoader) loader(this, false)
                this.getScrappedName()
            }
            catch (error) {
                if (!isLoader) loader(this, false)
                console.warn('A/P/P ERROR->', error)
            }
        },
        getScrappedName () {
            getAuthorScrappedNames({publication_id: this.$route.params.id}).then(response => {
                let scrappedAuthors = cloneDeep(response)
                let authors = cloneDeep(this.formData.authors)
                let newAuthors = []
                authors.map(author => {
                    scrappedAuthors.map(scrappedAuthor => {
                        if (scrappedAuthor.author_id === author._id) {
                            scrappedAuthor.scrapped_name.map(scrappedName => {
                                newAuthors.push({...author, scrapped_name: (scrappedName || '')})
                            })
                        }
                    })
                })
                this.updateFormData('AUTHORS', newAuthors)
            }).catch(error => {
                console.error(error)
            })
        },
        setValues (data) {
            this.urls = data.url
            this.des = {
                biography: data.biography || '',
                short_description: data.short_description || ''
            }
            this.imagePreview = data.avatar_image || null
            this.publicationImage = {
                avatar_image: data.avatar_image || '',
                imagePreview: data.imagePreview || null,
                _id: data._id
            }
            this.publicationLanguage = data.language || {}

            this.publication = {
                name: data.name,
                language: (data.language && data.language.display_name) || '',
                screen_name: data.screen_name || ''
            }
            this.languageName = (data.language && data.language.display_name) || ''
            this.socialMedia = {
                social_media: data.social_media || [],
                _id: data._id
            }
            this.address = {
                line1: (data.address && data.address.line1 && data.address.line1) || '',
                line2: (data.address && data.address.line2 && data.address.line2) || '',
                city: (data.address && data.address.city && data.address.city) || '',
                postal_code: (data.address && data.address.postal_code && data.address.postal_code) || '',
                country_code: (data.address && data.address.country_code && data.address.country_code) || '',
                country_name: (data.address && data.address.country_name && data.address.country_name) || ''
            }
            this.publisher = data.publisher
            this.authors = data.authors || []
            this.managing_editor = data.managing_editor || ''
            this.copyRight = data.copy_right || ''
            if (this.publication.screen_name === '') {
                this.createMetaScreenName()
            }
        },
        updateFormData (type, data) {
            switch (type) {
                case 'NAME':
                    this.formData.name ? this.formData.name = data.name : this.formData['name'] = data.name
                    this.formData.language ? this.formData.language = data.language : this.formData['language'] = data.language
                    this.formData.screen_name ? this.formData.screen_name = data.screen_name : this.formData['screen_name'] = data.screen_name
                break
                case 'DESCRIPTION':
                    this.formData.biography ? this.formData.biography = data.biography : this.formData['biography'] = data.biography
                    this.formData.short_description ? this.formData.short_description = data.short_description : this.formData['short_description'] = data.short_description
                break
                case 'LOCATION':
                    this.formData.address ? this.formData.address = data : this.formData['address'] = data
                break
                case 'PUBLISHER':
                    this.formData.publisher ? this.formData.publisher = cloneDeep(data) : this.formData['publisher'] = cloneDeep(data)
                break
                case 'IMAGE':
                    if (data !== undefined && data !== null) {
                        this.formData.avatar_image ? this.formData.avatar_image = data : this.formData['avatar_image'] = data
                    }
                break
                case 'SOCIAL_MEDIA':
                    this.formData.social_media ? this.formData.social_media = data.social_media : this.formData['social_media'] = data.social_media
                break
                case 'AUTHORS': 
                    this.formData.authors ? this.formData.authors = data : this.formData['authors'] = data
                break
                case 'MANAGING_EDITOR': 
                    this.formData.managing_editor ? this.formData.managing_editor = data : this.formData['managing_editor'] = data
                break
                case 'COPY_RIGHT':
                    this.formData.copy_right ? this.formData.copy_right = data : this.formData['copy_right'] = data
                break
                case 'URL':
                    this.formData.url ? this.formData.url = data : this.formData['url'] = data
                break

            }
            this.contentData = cloneDeep(this.formData)
            this.setValues(this.contentData)        
        },
        /**
         * publication name form submit
         */
        editPublicationName (formName) {
            this.$refs[formName].validate(async(valid) => {
            if (!valid) return 
                loader(this, true)
                let publication = cloneDeep(this.publication)
                let language = !isEmpty(this.selectedLanguage) ? cloneDeep(this.selectedLanguage) : cloneDeep(this.publicationLanguage)
                if (this.publication.screen_name !== '') {
                    let result = await this.validateMetaScreenName()
                    if (!result.isUnique) {
                        loader(this, false)
                        message(this, constants.messageType.SUCCESS, "Screen name is already taken")
                        return
                    }
                }
                let body = {
                    name: publication.name,
                    screen_name: publication.screen_name
                }
                if (!isEmpty(language)) {
                    body.language = cloneDeep(language)
                    body.language.language_id = language._id
                    body.language.operation= 'ADD'
                    delete body.language._id
                    delete body.language.createdAt
                    delete body.language.updatedAt
                }
                body.entity_ids = [this.$route.params.id]
                bulkUpdate(this.category.toLowerCase(), body).then(() => {
                    this.updateFormData('NAME',{name: publication.name, language: cloneDeep(language), screen_name: publication.screen_name})
                    message(this, constants.messageType.SUCCESS, "Updated Successfully")
                    this.selectedLanguage = {}
                    loader(this, false)
                }).catch(error => {
                    this.selectedLanguage = {}
                    loader(this, false)
                    return error
                }) 
            })
        },
        EditPublicationDescription (formName) {
            let description = cloneDeep(this.des)
            this.$refs[formName].validate((valid) => {
                if (!valid) return 
                    loader(this, true)
                    let body = description
                    body.entity_ids = [this.$route.params.id]
                    bulkUpdate(this.category.toLowerCase(), body).then(() => {
                        message(this, constants.messageType.SUCCESS, "Updated Succesfully")
                        this.updateFormData('DESCRIPTION', description)
                        loader(this, false)
                    }).catch(error => {
                        loader(this, false)
                        return error
                    }) 
            })
        },
        editPublicationLocation (location) {
            let address = cloneDeep(location)
            if (this.address.line1 !== address.line1 || this.address.line2 !== address.line2 || this.address.city !== address.city || this.address.postal_code !== address.postal_code || this.address.country_code !== address.country_code) {
                loader(this, true)
                let body = {address}
                body.entity_ids = [this.$route.params.id]
                bulkUpdate(this.category.toLowerCase(), body).then(() => {
                    message(this, constants.messageType.SUCCESS, "Updated Successfully")
                    this.updateFormData('LOCATION', address)
                    loader(this, false)
                }).catch(error => {
                    console.error(error)
                    loader(this, false)
                })         
            }
        },
        EditPublicationEditorForm () {
            loader(this, true)
            let body = {
                managing_editor: this.managing_editor,
                entity_ids: [this.$route.params.id]
            }
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.updateFormData('MANAGING_EDITOR', this.managing_editor)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
                loader(this, false)
            }).catch(error => {
                console.error(error)
                loader(this, false)
            })
        },
        EditPublicationCopyrightForm () {
            loader(this, true)
            let body = {
                copy_right: this.copyRight,
                entity_ids: [this.$route.params.id]
            }
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.updateFormData('COPY_RIGHT', this.copyRight)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
                loader(this, false)
            }).catch(error => {
                console.error(error)
                loader(this, false)
            })
        },
        editSocialMediaLinks () {
        },
        setMetaToAdd (item) {
            this.metaToAdd = item
        },
        setMetaAuthor (item) {
            this.metaAuthor = item
        },
        getUserRights: async function () {
            try {
                let body = {
                    type: this.category,
                    entity_id: this.$route.params.id
                }
                let users = await userRights(body)
                this.getUserData = users.user || {}
            }
            catch (error) {
                return error
            }
        },
        addUser: async function () {
            if(isEmpty(this.metaToAdd) || (this.metaToAdd._id === this.getUserData._id)) {
                this.metaToAdd = {}
                return
            }          
            try {
                loader(this, true)
                let body= {
                    user_admin_action : {
                        user_id: this.metaToAdd._id,
                        action: 'REPLACE_WITH'
                    },
                    entity_ids: [this.$route.params.id]        
                }
                await bulkUpdate(this.category.toLowerCase(), body)
                this.getUserData = cloneDeep(this.metaToAdd)
                this.metaToAdd = {}
                loader(this, false)
            } catch (error) {
                this.metaToAdd = {}
                loader(this, false)
                return error
            }            
        },
        removeUser () {
            if (isEmpty(this.getUserData)) return
            loader(this, true)
            let body= {
                user_admin_action : {
                    user_id: '',
                    action: 'REMOVE'
                },
                entity_ids: [this.$route.params.id]
            }            
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.getUserData = {}
                loader(this, false)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
            }).catch(error => {
                loader(this, false)
                return error
            })
            this.metaToAdd = {}
        },
        addPublisher () {
            if (isEmpty(this.metaToAdd) || this.publisher._id === this.metaToAdd._id) {
                this.metaToAdd = {}
                return
            }
            let publisher = cloneDeep(this.metaToAdd)
            loader(this, true)
            bulkUpdate(this.category.toLowerCase(),{publisher: this.metaToAdd._id, entity_ids: [this.$route.params.id]}, ).then(() => {
                this.publisher = cloneDeep(this.metaToAdd)
                this.updateFormData('PUBLISHER', publisher)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
                this.metaToAdd = {}
                loader(this, false)
            }).catch(error => {
                this.metaToAdd = {}
                loader(this, false)
                return error
            })
           
        },
        removePublisher () {
            loader(this, true)
            bulkUpdate(this.category.toLowerCase(), {publisher: '',entity_ids: [this.$route.params.id]}).then(() => {
                this.publisher = {}
                this.updateFormData('PUBLISHER', this.publisher)
                message(this, constants.messageType.SUCCESS, "Updated Successfully")
                loader(this, false)
            }).catch(error => {
                loader(this, false)
                return error
            })
            this.metaToAdd = {}
        },
        removeAuthor: async function (item) {
            try {
                loader(this, true)
                let author = {
                    operation : 'DELETE',
                    author_id: item._id,
                }
                await bulkUpdate(this.category.toLowerCase(),{author, entity_ids: [this.$route.params.id]})
                let authors = cloneDeep(this.authors)
                authors = authors.filter(author => author._id !== item._id)
                message(this, constants.messageType.SUCCESS, "Author removed successfully")
                this.updateFormData('AUTHORS', authors)
                loader(this, false)
            }
            catch (error) {
                console.error(error)
                loader(this, false)
            }
        },
        handleCommand (command, data) {
            switch (command) {
                case 'NEW':
                    this.isAddNewAuthor = true
                break
                case 'EDIT':
                    this.$router.push({name: 'editAuthors', params: {id: data._id}})
                break
                case 'DELETE': 
                    this.removeAuthor(data)
                break
                case 'CHANGE_GUID':
                    this.currentAuthor = data
                    this.isChangeGuid = true
                break
                case 'REFRESH': 
                    this.refreshOrigin(data)
                    break
            }
            
        },
        handleCommandOrigin (command, data) {
            switch (command) {
                // case 'EDIT':
                //     this.$router.push({name: 'editAuthors', params: {id: data._id}})
                // break
                // case 'DELETE': 
                //     this.removeAuthor(data)
                // break
                case 'REFRESH': 
                    this.refreshOrigin(data)
                    break
            }
        },
        validateField (rule, value, callback) {
            let pattern = /^[^a-zA-Z0-9]+$/;
            if (!isEmpty(value) && pattern.test(value)) callback(new Error('Invalid characters'))
            else callback() 
        },
        refreshOrigin (data) {
            loader(this,true)
            refreshOrigin(data._id).then((res) => {
                if(res.success) {
                    message(this, constants.messageType.SUCCESS, res.message)
                } else {
                    message(this, constants.messageType.ERROR, res.message)
                }
                loader(this,false)
            }).catch((err) => {
                loader(this,false)
                console.log(err)
            })
        },
        buttonAction(type, isTrue) {
            this.isAddNewAuthor = false
            if (isTrue) {
                this.getMetaList(this.category)
            }
        },
        changeLanguage (language) {
            this.selectedLanguage = cloneDeep(language)
            this.languageName = language.display_name
        },
        querySearch (query, cb) {
            if (query !== '' && query !== null && query.length > 1 ) {
                let results = []
                let languages = cloneDeep(this.languages)
                if (!isEmpty(languages)) {
                   results = filter(languages, (language) => {
                        return language.display_name.toLowerCase().includes(query.toLowerCase())
                    })
                }
                cb(results)
            }
        },
        handle (command) {
            switch (command) {
                case 'COPY':
                    copyElement(this.$route.params.id)
                break
                case 'SHOW_IN_IP':
                        this.$router.push({name: `publication-overview`, params: this.$route.params.id})
                break
                case 'REPLACE':
                    this.isReplace = true
                break
                case 'REMOVE': 
                    this.removeMeta()
                break
            }
        },
        disabledDiscriptionForm () {
            if (isEmpty(this.formData.short_description) && isEmpty(this.formData.biography) && isEmpty(this.des.short_description) && isEmpty(this.des.biography)) return true
            if (this.formData.short_description !== this.des.short_description || this.formData.biography !== this.des.biography) return false
            return true
        },
        disabledNameForm () {
            if (this.formData.name !== this.publication.name || (!isEmpty(this.selectedLanguage) && this.publicationLanguage._id !== this.selectedLanguage._id) || this.formData.screen_name !== this.publication.screen_name) return false
            return true
        },
        copyAuthor () {
            if (isEmpty(this.metaAuthor)) return
            copyElement(this.metaAuthor._id)
        },
        replaceButtonAction (action, isTrue) {
            this.isReplace = false
            if (isTrue) {
                this.$store.dispatch('setCallPublishers', {label: 'Publications', className: 'info'})
            }
        },
        disabledEditorForm () {
            if (isEmpty(this.formData.managing_editor) && this.managing_editor === '') return true
            if (this.formData.managing_editor !== this.managing_editor) return false
            return true
        },
        disabledCopyrightForm () {
            if (isEmpty(this.formData.copy_right) && this.copyRight === '') return true
            if (this.formData.copy_right !== this.copyRight) return false
            return true
        },
        removeMeta () {
            let body = {
                entity_ids: [this.$route.params.id],
                delete_from_ecosystem: true
            }
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                this.$store.dispatch('setCallPublishers', {label: 'Publications', className: 'info'})
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
            })
        },
        removeUrl (item) {
            loader(this,true)
            let url =  this.urls.filter(value => value !== item)
            let body = {
                entity_ids: [this.$route.params.id],
                url
            }
            bulkUpdate(this.category.toLowerCase(), body).then(() => {
                message(this, constants.messageType.SUCCESS, "Updated successfully")
                this.updateFormData('URL', url)
                this.urlToAdd = {url: ''}
                loader(this, false)
            }).catch(error => {
                console.error(error)
                loader(this, false)
            })
        },
        addUrl (formName, item) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return 
                loader(this, true)
                let url = cloneDeep(this.urls)
                url.push(item)
                let body = {
                    entity_ids: [this.$route.params.id],
                    url
                }
                bulkUpdate(this.category.toLowerCase(), body).then(() => {
                    message(this, constants.messageType.SUCCESS, "Updated successfully")
                    this.updateFormData('URL', url)
                    this.urlToAdd = {url: ''}
                    loader(this, false)
                }).catch(error => {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false)
                }) 
            })
        },
        validateUrl (rule, value, callback) {
            let regex = /^[a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/
            // if (isEmpty(value)) callback(new Error('Invalid Url'))
            if (!regex.test(value)) callback(new Error('Invalid Url'))
            else callback()
        },
        removeImage () {
            loader (this, true)
            let body = {
               avatar_image: '',
               entity_ids: [this.$route.params.id]
           }
           bulkUpdate(this.category.toLowerCase(), body).then(() => {
               this.updateFormData('IMAGE', '')
               loader(this, false)
           }).catch(error => {
               console.error(error)
               loader(this, false)
           })
        },
        sortPublicationByName () {
            this.sort = ! this.sort
            let authors = cloneDeep(this.authors)
            this.authors = orderBy(authors, 'name', this.sort ? 'desc' : 'asc')
        },
        sortOnScrappedName () {
            this.sortScrappedName = ! this.sortScrappedName
            let authors = cloneDeep(this.authors)
            authors.sort(function (first, second) {
                let name1 = first.scrapped_name && first.scrapped_name ? first.scrapped_name : ''
                let name2 = second.scrapped_name && second.scrapped_name ? second.scrapped_name : ''
                if (name1 < name2) return -1 // sort string ascending
                if (name1 > name2) return 1
                return 0
              })
            this.authors = authors
        },

        /**
         * to allow dragging and dropping only 
         * if the node is on the same level
         */
        allowDrop(draggingNode, dropNode, type) {
            if (type === 'inner') return false
            return true
        },

        /**
         * to get the listing of tree for content url
         */
        getContentList () {
            
            // body for the api
            let body = {
                publication_id: this.$route.params.id
            }

            // api call
            getPublicationContentList(body).then(response => {
                this.treeData = cloneDeep(response.result || [])
            }).catch(error => {
                console.error('error', error)
            })
        },

        /**
         * create new content url for the publication
         */
        creatContentList () {
            // to check if the same url already exists
            if (this.checkIfUrlExist(this.generatePath(this.contentDomain, this.contentPath))) {
                message(this, constants.messageType.ERROR, 'Content URL should be unique')
                return
            }
            loader(this, true)
            // body for api
            let body = {
                name: this.contentLabel,
                url: this.contentDomain,
                path: this.contentPath,
                full_url: this.generatePath(this.contentDomain, this.contentPath),
                publication: this.$route.params.id,
                order: this.treeData.length + 1
            }

            // api call
            createPublicationContentList(body).then(response => {
                // cloneDeep to the original data to do the manipulation and sorting
                let treeData = cloneDeep(this.treeData)
                treeData.push(response.result)
                // sort list by order
                this.treeData = sortBy(treeData, 'order')
                // clearing fields
                this.clearContentFields()
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
                loader(this, false)
            })   
        },
        /**
         * to generatePath for the node
         */
        generatePath (domain, path) {
            // to check if last char is '/'
            if (domain !== '' && domain.charAt(domain.length - 1) === '/') {
                domain = domain.slice(0, -1)
            }
            // to check if path already contains '/'
            if (path !== '' && path.charAt(0) === '/') {
                path = path.slice(1)
            }
            return `${domain}/${path}`
        },
        /**
         * to check if full_url already existed
         * @param {*} url 
         */
        checkIfUrlExist (url) {
            let isFind = false
            this.treeData.map(tree => {
                if (tree.full_url && tree.full_url === url) isFind = true
            })
            return isFind
        },
        /**
         * to clear the content url fields after creation
         */
        clearContentFields () {
            this.contentDomain = ''
            this.contentLabel = ''
            this.contentPath = ''
        },

        /**
         * disable create button(new)
         */
        disabledContentButton () {
            if (this.contentPath !== '' && this.contentDomain !== '' && this.contentLabel !== '') return false
            return true
        },

        /**
         * update the content url listing
         * @param {*} node node to get updated
         */
        updateContentList (node) {
            try {
                // body for api
                let body = {
                    name: node.name,
                    url: node.url,
                    path: node.path,
                    full_url: this.generatePath(node.url, node.path),
                    publication: this.$route.params.id,
                    order: node.order
                }
                // api call
                updatePublicationContentList(body, node._id)
            } catch (error) {
                return error
            }
        },

        /**
         * to remove the node from tree
         * @param {*} node to be deleted
         */
        removeContentList (node) {
            removePublicationContentList(node._id).then(() => {
                let treeData = cloneDeep(this.treeData)
                // to filter the treeData
                treeData = treeData.filter((tree) => {
                    if (tree._id !== node._id) return tree
                })
                // to update the treeData
                this.treeData = treeData
                // to update backend wit the new order
                this.nodeDrop()
            }).catch(error => error)
            
        },
        
        /**
         * event which is fired when node is droped
         */
        nodeDrop () {
            // if empty return
            if (isEmpty(this.treeData)) return
            loader(this, true)
            // map to get the id and order to be updated
            let contents = []
            this.treeData.map((tree, index) => {
                tree.order = index + 1 
                contents.push({
                    id: tree._id,
                    order: tree.order
                })
            })
            let body = {contents}
            // api call
            bulkUpdatePublicationContentList(body).then(() => {
                loader(this, false)
            }).catch(() => {
                loader(this, false)
            })
        },
        validateMetaScreenName: async function () {
            // body for api
            let body = {
                entity_type: this.category,
                screen_name: this.publication.screen_name,
                entity_id: this.$route.params.id
            }
            // api call
            return await validateScreenName(body)
        },

        /**
         * to crete the screen name if screen name is not present
         */
        createMetaScreenName () {
            // body for api
            let body = {
                entity_type: this.category,
                name: this.publication.name
            }
            // api call
            createScreenName(body).then(response => {
                // assign screen name
                this.$set(this.publication, 'screen_name', response.response)
            }).catch(error => {
                message(this, constants.messageType.ERROR, error.message)
            })
        },

        /**
         * to get the origin filters
         * @param {*} data formData
         */
        getFeedsList: async function (data) {
            let urls = data.rss_url || []
            try {
                let feeds = await getFeedsOriginList({urls})
                this.feedData = feeds.origins || []
            } catch (error) {
                message(this, constants.messageType.ERROR, error.message)
            }
        },
        getDate (date) {
            if (date !== undefined && date !== null) {
              let d = new Date(date)
              return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
                d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
            }
        },

        /**
         * change guid of the author
         */
        async changeAuthorGUID () {
            try {
                this.isProgress = true
                this.percentage = 30
                // body for api
                let body = {
                    current_author: this.currentAuthor._id,
                    current_publication: this.$route.params.id,
                    merge_to: {
                        author_id: this.authorToBeReplaced._id
                    }
                }
                // api call
                let response = await mergeScrappedName(body)
                this.percentage = 70
                this.getMetaList(this.category, undefined, true)
                message(this, constants.messageType.SUCCESS, "Successfully merged author")
                this.percentage = 100
                this.isFinal = true
            } catch (error) {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            finally {
                this.isProgress = false
            }
        },

        /**
         * handle search
         * @param {*} type 
         * @param {*} value 
         */
        handleSearch (type, value) {
            this.authorToBeReplaced = value
        },

        /**
         * on close of popup
         */
        closeChangeGuidPopup () {
            this.authorToBeReplaced = {}
            this.currentAuthor = {}
            this.isProgress = false
            this.isFinal = false
            this.authorSearch = ''
            this.percentage = 0
        },

        /**
         * publication author search
         * @param {*} query 
         * @param {*} cb 
         */
        querySearchAuthor (query, cb) {
            let result = []
            if (query !== '' && query !== null && query.length > 1 ) {
                const search = query.toLowerCase()
                result = this.authors.filter(author =>{
                    if (author.first_name && author.first_name.includes(search) || (author.last_name && author.last_name.includes(search)) ||  (author.middle_name && author.middle_name.includes(search)) || author._id.includes(search)) return author
                })

                result = uniqBy(result, '_id')
                
            }
            cb(result)
        },
        /**
         * select search author
         * @param {*} item 
         */
        handleSelectAuthor (item) {
            this.authorToBeReplaced = item
            this.authorSearch = item.name || item.first_name || ''
        }
    }
}